module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-vehicle-availability"
  }, [_vm._m(0), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('search-vehicle-availability', {
    attrs: {
      "vehicle": _vm.vehicle
    },
    on: {
      "slotsSelected": _vm.book
    }
  }, [_c('label', [_vm._v("Driver"), _c('selectize-driver', {
    on: {
      "optionSelected": _vm.selectDriver
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Availability")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fbfd2db!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleAvailability.vue
// module id = 2485
// module chunks = 1